import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", redirect: { name: "AuthException" } },
    {
      name: "AuthException",
      path: "/error/AuthException",
      component: () => import("../views/AuthException.vue"),
      //component: () => import("../../../components/CommonError.vue"),
    },
    {
      name: "PageNotFound",
      path: "/error/PageNotFound",
      //component: () => import("../views/PageNotFound.vue"),
      component: () => import("../../../components/CommonError.vue"),
    },
    {
      name: "SessionInvalidate",
      path: "/error/SessionInvalidate",
      component: () => import("../views/SessionInvalidate.vue"),
      //component: () => import("../../../components/CommonError.vue"),
    },
    {
      name: "commonError",
      path: "/error/commonError",
      component: () => import("../../../components/CommonError.vue"),
    },
  ],
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 });
      }, 300);
    });
  },
});
